import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home mb-20 mt-20" }
const _hoisted_2 = {
  key: 0,
  class: "carousel-container"
}
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.brands.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "carousel",
            style: _normalizeStyle({ transform: `translateX(-${_ctx.currentIndex * (100 / _ctx.brandsPerSlide)}%)` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandsToDisplay, (brand, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "carousel-item"
              }, [
                _createElementVNode("img", {
                  src: brand.logo,
                  alt: brand.name,
                  class: "carousel-img"
                }, null, 8, _hoisted_3)
              ]))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createStaticVNode("<section class=\"section\" data-v-4a5311ae><h2 class=\"section-title\" data-v-4a5311ae>Monturas Oftalmológicas</h2><p class=\"section-description\" data-v-4a5311ae>Encuentra las mejores monturas oftalmológicas para tus lentes, diseñadas para ofrecer comodidad y estilo.</p><div class=\"items-container\" data-v-4a5311ae></div><div class=\"alert\" data-v-4a5311ae>No hay monturas oftalmológicas disponibles</div></section><section class=\"section\" data-v-4a5311ae><h2 class=\"section-title\" data-v-4a5311ae>Monturas de Sol</h2><p class=\"section-description\" data-v-4a5311ae>Descubre las monturas de sol más modernas y cómodas para proteger tus ojos mientras luces increíble.</p><div class=\"items-container\" data-v-4a5311ae></div><div class=\"alert\" data-v-4a5311ae>No hay monturas de sol disponibles</div></section><section class=\"section\" data-v-4a5311ae><h2 class=\"section-title\" data-v-4a5311ae>Provador Virtual</h2><p class=\"section-description\" data-v-4a5311ae>Prueba virtualmente nuestras monturas y encuentra la que mejor se adapte a tu rostro, ¡todo desde la comodidad de tu hogar!</p><div class=\"items-container\" data-v-4a5311ae></div><div class=\"alert\" data-v-4a5311ae>No hay items disponibles para el provador virtual</div></section>", 3))
  ]))
}